import Vue from 'vue'
// import store from '../store'
import {isEmpty, isNumber, toNum, getLocalValue, setLocalValue, removeLocalValue, dateFormat, rmEmptyValueFromJson, setStoreInfo, getStoreInfo, getDataListById, getEntityInfoById, getDataFormById} from '../utils/commonUtil'
// 设置导航栏标题
Vue.prototype.setNavTitle = function (metaTitle) {
  document.title = metaTitle || document.title
  let ifr = document.createElement('iframe')
  ifr.onload = function () {
    setTimeout(function () {
      ifr.remove()
    }, 0)
  }
  document.body.appendChild(ifr)
}
/**
 * @method 使用store缓存一些数据
 * @param module 实体
 * @param key 存的键
 * @param value 存的值
 */
Vue.prototype.setStoreInfo = (module, key, value) => setStoreInfo(module, key, value)
/**
 * @method 获取store缓存的数据
 * @param module 实体
 * @param key 存的键
 * @param value 存的值
 */
Vue.prototype.getStoreInfo = (module, key) => getStoreInfo(module, key)
/**
 * 判断对象为空
 * @param v
 * @return {boolean}
 */
Vue.prototype.isEmpty = (value) => isEmpty(value)
/**
 * 判断对象是否为数字
 * @param v
 * @return {boolean}
 */
Vue.prototype.isNumber = (value) => isNumber(value)
/**
 * @method 存储数据到localStorage中
 * @param {*key值} key
 * @param {*值} val
 */
/**
 * 将对象转为数字
 * @param v
 * @return {boolean}
 */
Vue.prototype.toNum = (value) => toNum(value)
/**
 * @method 存储数据到localStorage中
 * @param {*key值} key
 * @param {*值} val
 */
Vue.prototype.setLocalValue = (key, value) => setLocalValue(key, value)
/**
 * @method 获取localStorage中某个的数据
 * @param {*key值} key
 */
Vue.prototype.getLocalValue = (key) => getLocalValue(key)
/**
 * @method 移除localStorage中某个的数据
 * @param {*key值} key
 */
Vue.prototype.removeLocalValue = (key) => removeLocalValue(key)

/**
 * @method 封装错误信息
 * @param err 错误信息对象
 */
Vue.prototype.transFormErrorMsg = function (err) {
  if(err.response) {
    let errObj = err.response.data || {}
    console.error(errObj)
    window.vm.$toast.show({
      type: 'error',
      content: errObj.error.message || '请稍后重试', // 默认为空字符串，不传将不显示文案
      position: 'middle', // 默认为middle，居中显示
    })
  } else {
    console.error(err)
  }
}

/**
 * 日期对象转为日期字符串
 * @param date 需要格式化的日期对象
 * @param sFormat 输出格式,默认为yyyy-MM-dd                         年：y，月：M，日：d，时：h，分：m，秒：s
 * @example  dateFormat(new Date())                                "2017-02-28"
 * @example  dateFormat(new Date(),'yyyy-MM-dd')                   "2017-02-28"
 * @example  dateFormat(new Date(),'yyyy-MM-dd hh:mm:ss')         "2017-02-28 09:24:00"
 * @example  dateFormat(new Date(),'hh:mm')                       "09:24"
 * @example  dateFormat(new Date(),'yyyy-MM-ddThh:mm:ss+08:00')   "2017-02-28T09:24:00+08:00"
 * @returns {boolean}
 */
Vue.prototype.dateFormat = (date, sFormat) => dateFormat(date, sFormat)

/**
 * @method 移除json中为空的数据
 * @param {*json参数} params
 */
Vue.prototype.rmEmptyValueFromJson = (params) => rmEmptyValueFromJson(params)

/**
 * @method 数字转字符串
 * @param 参数
 */
Vue.prototype.numberToString = function (value) {
  let flag = typeof value === 'number' && !isNaN(value)
  return flag ? value.toString() : value
}
/**
 * @method 根据共同字段将数据分组
 */
Vue.prototype.groupingData = function (data, filed) {
  let map = {}
  let dest = []
  data.forEach(item => {
    if(!map[item[filed]]) {
      dest.push({
        [filed]: item[filed],
        list: [item],
      })
      map[item[filed]] = item
    } else {
      dest.forEach(dItem => {
        if(dItem[filed] === item[filed]) {
          dItem.list.push(item)
        }
      })
    }
  })
  return dest
}
/**
 * @method 正则去掉所有的html标记
 */
Vue.prototype.delHtmlTag = function (str) {
  return str.replace(/<[^>]+>/g, '')
}
// function dealFunc (e) {
//   e.preventDefault() // 阻止默认的处理方式(阻止下拉滑动的效果)
// }
// /**
//  * @method 添加监听
//  */
// Vue.prototype.addBodyScrollListener = function () {
//   document.body.addEventListener(
//     'touchmove',
//     dealFunc,
//     {passive: false}
//   ) // passive 参数不能省略，用来兼容ios和android
// }
// /**
//  * @method 移除监听
//  */
// Vue.prototype.removeBodyScrollListener = function () {
//   document.body.removeEventListener(
//     'touchmove', dealFunc, {passive: false}
//   )
// }

/**
 * @method 根据id获取单条记录信息
 * @param {tcode} tcode
 * @param {实体id} entityId
 * @param {成功callback} success
 */
Vue.prototype.getEntityInfoById = (tcode, entityId, success) => getEntityInfoById(tcode, entityId, success)
/**
 * @method 根据id获取列表数据
 * @param {tcode} tcode
 * @param {实体id} entityId
 * @param {成功callback} success
 */
Vue.prototype.getDataListById = (tcode, entityId, success, error) => getDataListById(tcode, entityId, success, error)

/**
 * @method 根据id获取表单数据
 * @param {tcode} tcode
 * @param {实体id} entityId
 * @param {成功callback} success
 */
Vue.prototype.getDataFormById = (tcode, entityId, success, error) => getDataFormById(tcode, entityId, success, error)



// WEBPACK FOOTER //
// ./src/utils/common.js